var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.exportAll()}}},[_vm._v("выгрузить все")]),_c('confirm-dialogue',{ref:"confirmDialogue"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }